import * as Yup from "yup";

export const getFormSchema = (t) => {
	return Yup.object().shape({
		emailReplyFrom: Yup.string()
			.required(t("this_field_is_required"))
			.email(t("invalid_email_format")),
		emailUsername: Yup.string().required(t("this_field_is_required")),
		emailPassword: Yup.string().required(t("this_field_is_required")),
		smtpHost: Yup.string().required(t("this_field_is_required")),
		smtpPort: Yup.string().required(t("this_field_is_required")),
		smtpEncryption: Yup.string().required(t("this_field_is_required")),
		smtpValidateCert: Yup.string().required(t("this_field_is_required")),
		imapHost: Yup.string(),
		imapPort: Yup.string(),
		imapEncryption: Yup.string(),
		imapValidateCert: Yup.string(),
	});
};
